import { __awaiter, __generator } from "tslib";
import { fetchManyEntities } from './http/fetch-many-entities';
export var fetchGroups = function (groupIds, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchManyEntities(groupIds, "g" /* Group */, includeType)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
